import React from 'react';

import { ContentComponent } from 'components';
import { TargetProvider } from 'providers/target/TargetProvider';

function Detail() {
  return (
    <>
      <TargetProvider>
        <ContentComponent.Editor />
        {/* <div
            css={[
              detailWrap,
              { marginTop: ' 24px', display: 'flex', gap: '0 24px' },
            ]}
          >
            <div
              css={{
                width: '325px',
                display: 'flex',
                flexDirection: 'column',
                height: '650px',
                border: '8px solid black',
                borderRadius: '8px',
                overflowY: 'scroll',
              }}
            >
              {contents.map((c, i) => (
                <div key={c.id} onClick={() => setSelectedIndex(i)}>
                  <ContentComponent.ContentsModule module={c} />
                </div>
              ))}
            </div>
            <div>
              {selectedModule !== null && (
                <ContentComponent.EditContentsModule
                  module={selectedModule}
                  handleChange={handleChange}
                />
              )}
            </div>
          </div> */}
      </TargetProvider>
    </>
  );
}

export default Detail;
